import { AxiosPromise } from 'axios';
import { MailchimpAuthData } from '@dev/ee-api/ee-api-models';
import { request } from './request';

export const getMailchimpAccessData = (
    code: string,
    clientid?: string,
    clientsecret?: string,
    redirectUri?: string
): AxiosPromise<MailchimpAuthData> => {
    const { Integration } = request();
    if (code && clientid && clientsecret && redirectUri) {
        return Integration.integrationMailchimpAuthPost(code, clientid, clientsecret, redirectUri);
    }
    return Integration.integrationMailchimpAuthPost(code);
};

export const getMailchimpApiData = (
    accessToken: string,
    dc: string,
    path: string,
    params: Record<string, string | number | boolean>,
    method: string
): AxiosPromise<any> => {
    const { Integration } = request();
    return Integration.integrationMailchimpProxyPost(accessToken, dc, path, method, {
        params: {
            ...params,
        },
    });
};
